export default "./img/img-1c8831.jpg";